<div class="ui basic segments">
  <div *ngIf="isChatbotSelected">
    <div class="ui basic segment chatbot-header-segment">
      <div class="ui secondary inverted menu">
        <a class="item">
          <img
            class="ui right spaced mini avatar image"
            src="{{ chatbotDetail?.photoURL }}"
            alt="{{ chatbotDetail?.displayName }}"
          />
          <span class="text">
            <h3>{{ chatbotDetail?.displayName }}</h3>
          </span>
        </a>
      </div>
    </div>
    <div class="ui segment">
      <div class="chatbot-messages-segment">
        <cdk-virtual-scroll-viewport
          class="ui comments fluid"
          itemSize="messageList.length"
        >
          <div
            class="comment"
            *cdkVirtualFor="let message of messageList"
            [class.right-floated-comment]="loggedUser.uid === message.senderId"
          >
            <a class="avatar">
              <img src="{{ message?.photoURL }}" />
            </a>
            <div class="content">
              <div class="ui label">
                <div class="text">
                  <p>{{ message.message }}</p>
                </div>
                <div class="metadata">
                  <span class="date mini">{{
                    message.createdAt | date: 'shortTime'
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <div class="ui segment chatbot-footer-segment">
      <form
        class="ui reply form input-form"
        [formGroup]="chatForm"
        (ngSubmit)="sendMessage()"
      >
        <div class="ui fluid transparent input">
          <input
            type="text"
            placeholder="message..."
            formControlName="message"
          />
          <button type="submit" class="ui icon button">
            <i class="paper plane outline icon"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="!isChatbotSelected">
    <div class="ui placeholder segment">
      <div class="ui icon header">
        <i class="circular users icon"></i>
        Welecome to the chat
        <h2 class="ui center aligned">
          <a class="ui orange large label">Start conversation</a>
        </h2>
      </div>
    </div>
  </div>
</div>
